import {
  SET_PRICE,
  SET_AMOUNT,
  SET_COLLATERAL,
	SET_ORDER_TYPE,
  SET_MAKER_COLLATERAL,
  SET_HELP,
  SET_MARKET,
  SET_FINAL_ORDER,
  SET_LOADING,
  SET_MATCHING
} from '../actions/types';

import $ from 'jquery';
import {pairs} from '../config';
import {Decimal} from 'decimal.js';

let initialState =  {
  loading: false,
  matching:false,
  collateral: 100000,
  amount: null,
  price : null,
  orderType: "BUY",
  helpMode:false,
  market:{denomination:'NRG',asset:'BTC',type:'auction',sellSide:false},
  takeOrders: [],
  makerAmount: 0,
  makerCollateral:0,
  takerCollateral:0,
  spending: 0,
};

export default function(state: Object = initialState, action) {
  switch(action.type) {
    case SET_LOADING:
      return {...state,loading:action.payload}
    case SET_MATCHING:
      return {...state,matching:action.payload}
    case SET_AMOUNT :
      if($('#amount')[0]) $('#amount')[0].value = action.payload;
      return {...state, amount: action.payload};
    case SET_PRICE :
      return {...state, price: action.payload};
    case SET_MARKET:
      let {denomination,asset,type} = action.payload;
      if(!type) type = 'bid/ask';
      let market = pairs[type][`${asset.toUpperCase()}/${denomination.toUpperCase()}`];
      market.type = type;
      return {...state, market};
    case SET_ORDER_TYPE:
      return {...state, orderType: action.payload};
    case SET_COLLATERAL:
      return {...state, collateral:action.payload};
    case SET_MAKER_COLLATERAL:
      if(action.payload == '') action.payload = 0
      if(state.market.denomination.toUpperCase() === 'NRG') {
        return {...state, makerCollateral:action.payload,spending:new Decimal(state.takerCollateral).add(new Decimal(state.amount).mul(new Decimal(state.price))).toNumber()}
      }
      else {
        return {...state, makerCollateral:action.payload,spending:new Decimal(state.takerCollateral).add(new Decimal(action.payload)).toNumber()}
      }
    case SET_FINAL_ORDER:
      const {makerAmount,takeOrders,makerCollateral,takerCollateral,nrgCollateral} = action.payload
      return {...state,makerAmount,nrgCollateral,takeOrders,makerCollateral,takerCollateral,spending:new Decimal(makerCollateral).add(new Decimal(takerCollateral)).toNumber()};
    default:
      return state;
  }
}
